<template>
  <div id="kce-quiz-results" class="kce-quiz__results">
    <div class="quiz__results-wrapper">
      <div class="quiz__results-header">
        <button class="quiz__results-close" aria-label="Close dialog" type="button" @click="closeModal">
          <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M6.4141 5.00001L9.7071 1.70701C10.0981 1.31601 10.0981 0.684006 9.7071 0.293006C9.3161 -0.0979941 8.6841 -0.0979941 8.2931 0.293006L5.0001 3.58601L1.7071 0.293006C1.3161 -0.0979941 0.684097 -0.0979941 0.293097 0.293006C-0.0979026 0.684006 -0.0979026 1.31601 0.293097 1.70701L3.5861 5.00001L0.293097 8.29301C-0.0979026 8.68401 -0.0979026 9.31601 0.293097 9.70701C0.488097 9.90201 0.744097 10 1.0001 10C1.2561 10 1.5121 9.90201 1.7071 9.70701L5.0001 6.41401L8.2931 9.70701C8.4881 9.90201 8.7441 10 9.0001 10C9.2561 10 9.5121 9.90201 9.7071 9.70701C10.0981 9.31601 10.0981 8.68401 9.7071 8.29301L6.4141 5.00001Z"
              fill="#2E3192"></path>
          </svg>
        </button>
        <h2 class="kce__header">{{ this.resultHeader }}</h2>
      </div>
      <div class="quiz__results-content">
        <p class="quiz__results-answers"><span v-if="resultStatus == 'passed'">Congratulations <br /></span>
          {{ this.resultBody }}<span v-if="resultStatus == 'passed'"> {{ quizHeader }}</span>
        </p>
        <div class="quiz__results-answers">
          <div class="quiz__results-questions" v-if="resultStatus != 'notFilledOut'" v-for="result in resultQuestions">
            <p class="quiz__results-question">{{ result.question }}</p>
            <div v-if="result.answer != result.correctAnswer" class="result-quiz_answer">Incorrect: <span
                v-if="resultStatus == 'passed'">Answer is {{ result.correctAnswer }}</span><span v-else>{{
                  result.answer }}</span></div>
            <div v-else class="result-quiz_answer">Correct: {{ result.answer }}</div>
          </div>
        </div>
      </div>
      <p v-if="resultStatus != 'passed'" class="quiz__results-content">Good Luck!</p>
      <div class="quiz__results-action">
        <button class="kce-btn-secondary" type="button" @click="closeModal">{{ this.resultButton }}</button>
      </div>
    </div>
  </div>
</template>


<script>

export default {
  props: {
    resultStatus: String,
    quizHeader: String,
    resultQuestions: Array,
    showResults: Boolean,
    stepTracker: Number,
    clearFormData: Function,
    getData: Function
  },
  components: {
  },
  data() {
    return {
      resultHeader: "Sorry, try Again",
      resultBody: "Please answer all questions.",
      resultButton: "Try Again",
      currectStep: this.$props.stepTracker,
    };
  },
  async mounted() {
    console.log(this.currectStep, " = current step")
    switch (this.$props.resultStatus) {
      case "notFilledOut":
        this.resultHeader = "Sorry, try Again";
        this.resultBody = "Please answer all questions.";
        this.resultButton = "Try Again";
        break;
      case "failed":
        this.resultHeader = "Sorry, try Again";
        this.resultBody = "Too many incorrect. Please go back and try again.";
        this.resultButton = "Try Again";
        break;
      case "passed":
        this.resultHeader = "You Passed!";
        this.resultBody = "You Passed";
        this.resultButton = "Keep Going";
        break;
    }
  },
  beforeDestroy() { },
  methods: {
    closeModal() {
      if (this.$props.resultStatus == "passed") {
        this.currectStep = ++this.currectStep;
        this.$props.getData(this.currectStep);
        this.$emit('updated', false)
      }
      this.$props.clearFormData();
    }
  },
  computed: {
  }
}

</script>
<style scoped></style>